import 'mdn-polyfills/NodeList.prototype.forEach';
import Video from './Video';

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.js-figure');
  if (!videos.length) {
    return;
  }

  videos.forEach(element => {
    const video = new Video(element);
    video.mount(element);
    element.querySelector('.js-video-vignette').addEventListener('click', video.insertFrame);
  });
});
